import { Fragment, ReactNode, useState } from 'react';
import { Tabs, Box, Tab } from '@mui/material';
import styled from 'styled-components';
import { ShadowDivider } from '@shared/styledComponents';
import { muiTheme } from '@styles/muiTheme';

const TabsWrapper = styled(Tabs)<{ $colorOfIndicator?: string }>`
  .MuiTabs-indicator {
    background-color: ${({ $colorOfIndicator }) => $colorOfIndicator && $colorOfIndicator};
  }

  padding: 0 5px;
`;

interface LocalTabsProps {
  data: {
    name: string;
    component: ReactNode;
  }[];
  defaultActiveTab?: number;
  indicatorColor?: string;
  hideShadow?: boolean;
  scrollable?: boolean;
}

export const LocalTabs = ({
  data,
  defaultActiveTab = 0,
  hideShadow = false,
  scrollable = false,
}: LocalTabsProps) => {
  const [activeTab, setActiveTab] = useState(defaultActiveTab);

  return (
    <Box sx={{ width: '100%' }}>
      <TabsWrapper
        variant={scrollable ? 'scrollable' : 'standard'}
        scrollButtons={scrollable ? 'auto' : false}
        value={activeTab}
        $colorOfIndicator={activeTab ? muiTheme.palette.success.main : muiTheme.palette.info.dark}
        onChange={(_, tab) => setActiveTab(tab)}
      >
        {data.map((tab, index) => (
          <Tab
            key={index}
            label={tab.name}
          />
        ))}
      </TabsWrapper>

      {!hideShadow && <ShadowDivider />}

      <Fragment>
        {data[activeTab]?.component}
      </Fragment>
    </Box>
  );
};
